
import { h } from "preact";
//import { useState } from "preact/hooks";
import { Box, Breadcrumbs, Link, Stack, Typography } from "@mui/material";


import NavigateNextIcon from '@mui/icons-material/NavigateNext';

function handleClick(event) {
    event.preventDefault();

}


export default function NavBreadcrumbs({ from }) {
    const breadcrumbs = [
        <Typography underline="hover" key="1" color="inherit" href="/" onClick={() => window.location.href = "/dashboarda"}>
            Accueil
        </Typography >,
        <Typography
            underline="hover"
            key="2"
            color="inherit"
            href="/material-ui/getting-started/installation/"
            onClick={() => window.location.href = from}
        >
            Deal
        </Typography>,
        <Typography key="3" color="text.primary">
            Gestion des vendeurs
        </Typography>,
    ];
    // const breadcrumbs = [
    //     <Link underline="hover" key="1" color="inherit" href="/" onClick={() => window.location.href = "/dashboarda"}>
    //         Accueil
    //     </Link >,
    //     <Link
    //         underline="hover"
    //         key="2"
    //         color="inherit"
    //         href="/material-ui/getting-started/installation/"
    //         onClick={() => window.location.href = from}
    //     >
    //         Deal
    //     </Link>,
    //     <Typography key="3" color="text.primary">
    //         Gestion des vendeurs
    //     </Typography>,
    // ];

    return (

        <Breadcrumbs
            separator={<NavigateNextIcon fontSize="small" color="primary" />}
            aria-label="breadcrumb"
        >
            {breadcrumbs}
        </Breadcrumbs>

    );


}